import React from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { DetailedProviderContent } from '@kyruus/provider-components';
import { CareTeamList } from './CareTeamList';
import CardContainer from '../CardContainer/card-container';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';
import messages from '../../lib/messages';
import { TrackingFunction } from '../../lib/tracking-utils';
import { CareTeamHeader, CareTeamSubtitle, CareTeamTitle } from './styles';

interface CareTeamProps extends WrappedComponentProps {
  careTeamProviders: DetailedProviderContent[];
  createAvailabilityUrl: () => string;
  createProviderUrl: () => string;
  track: TrackingFunction;
}

export const CareTeam = withErrorBoundary(
  injectIntl(
    ({
      intl,
      careTeamProviders,
      createAvailabilityUrl,
      createProviderUrl,
      track
    }: CareTeamProps) => {
      const careTeamSubtitle = intl.formatMessage(messages.careTeamSubtitle);
      // default subtitle is empty
      const shouldShowSubtitle = careTeamSubtitle !== ' ';

      return (
        <CardContainer>
          <CareTeamHeader>
            <CareTeamTitle>
              {intl.formatMessage(messages.careTeamTitle)}
            </CareTeamTitle>
            {shouldShowSubtitle && (
              <CareTeamSubtitle>{careTeamSubtitle}</CareTeamSubtitle>
            )}
          </CareTeamHeader>
          <CareTeamList
            careTeamProviders={careTeamProviders}
            createAvailabilityUrl={createAvailabilityUrl}
            createProviderUrl={createProviderUrl}
            track={track}
          />
        </CardContainer>
      );
    }
  )
);
